module.exports = __webpack_public_path__ + "img/minimizeleft.4cbc0c03.svg";